import { ArtistNameSelector, HelperText } from './components';

type PropsType = {
  releaseId: string;
};
const ArtistName = ({ releaseId }: PropsType) => (
  <>
    <ArtistNameSelector releaseId={releaseId} />
    <HelperText />
  </>
);

export default ArtistName;
